export default "__VITE_ASSET__BFYK4TRr__"